import React from 'react';
import ContentLoader from 'react-content-loader';
import './CommentInputLoader.css';

const MyContentLoader = () => {
  return (
    <div styleName="loaderContainer">
      <ContentLoader
        speed={3}
        primaryColor="#d5d5d5"
        secondaryColor="#eaeaea"
        height={43}
        width={877}
        title=""
      >
        <circle cx="35" cy="20" r="20" />
        <rect x="65" y="1" width="795" height="40" rx="8" />
      </ContentLoader>
    </div>
  );
};

export { MyContentLoader as default };
